import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'hydra',
    loadChildren: () => import('./magnament/magnament.module').then(m => m.MagnamentModule)
  },{
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: 'login/logout',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },{
    path: '',
    redirectTo: '/hydra',
    pathMatch: 'full'
  }
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
